var _g, _line, _g2, _g3, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLengthtype08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "433.9px",
    height: "729px",
    viewBox: "0 0 433.9 729",
    enableBackground: "new 0 0 433.9 729",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.3,
    y: 96.4,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 119.5,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 433.8,
    y1: 693.8,
    x2: 0,
    y2: 693.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9532,
    strokeMiterlimit: 10,
    d: "M235.4,705c0,0,7.7,8.2,15.6,8.3 c7.9,0.1,14.6-7.3,14.6-7.3V52.4c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M265.6,706c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V52.4h-34.5V706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M300.1,706c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V52.4h-34.5V706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M334.6,706c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V52.4h-34.5V706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M369.1,706c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V52.4h-34.5V706z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 34,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.7037,
    width: 404.4,
    height: 13
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 407.8,
    y: 32,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 32,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthtype08);
export default __webpack_public_path__ + "static/media/length type-08.3347ffb41866719d43077da6996a2134.svg";
export { ForwardRef as ReactComponent };